module.exports = __webpack_public_path__ + "public/Icons/completed.svg?d70d9147";